<kt-portlet>
    <!-- See prop => '../../_core/models/data-sources/_base.datasource.ts' (loading$) -->
    <kt-portlet-header [class]="'kt-portlet-head--lg'" [viewLoading$]="dataSource.loading$"
                       [tooltipTitle]="'TOOLTIP.ASSIGNMENT.LIST.TITLE' | translate"
                       [tooltipDesc]="'TOOLTIP.ASSIGNMENT.LIST.DESCRIPTION' | translate">
        <!-- PORTLET LOADING | Binded to TABLE Datasource -->

        <ng-container ktPortletTitle>
            <h3 class="card-head-title">
                <span>
                    {{ 'ASSIGNMENT.LIST.TITLE' | translate }}
                </span>
            </h3>
        </ng-container>

        <ng-container ktPortletTools>
            <button (click)="addAssignment()" mat-raised-button
                    [matTooltip]="'ASSIGNMENT.LIST.BUTTON.NEW.TOOLTIP' | translate" color="primary" type="button"
                    class="mr-2"
            >
                <span>
                    {{ 'ASSIGNMENT.LIST.BUTTON.NEW.LABEL' | translate }}
                </span>
            </button>
            <button *ngIf="(trashCnt$ |async) != 0" (click)="trash()" mat-raised-button
                    [matTooltip]="'ASSIGNMENT.LIST.BUTTON.TRASHED.TOOLTIP' | translate" type="button" class="button-gray"
            >
                <span>
                    {{ 'GENERAL.BUTTON.TRASHED' | translate }} ({{trashCnt$ |async }})
                </span>
            </button>
            <button *ngIf="(adminTrashCnt$ |async) != 0 && (canAccessAdminTrash$|async)" (click)="adminTrash()" mat-raised-button
                    [matTooltip]="'ASSIGNMENT.LIST.BUTTON.ADMIN_TRASHED.TOOLTIP' | translate" type="button" class="button-gray ml-2"
            >
                <span>
                    {{ 'GENERAL.BUTTON.ADMIN_TRASHED' | translate }} ({{adminTrashCnt$ |async }})
                </span>
            </button>
        </ng-container>
    </kt-portlet-header>
    <!-- end::Header -->

    <kt-portlet-body>
        <div class="kt-margin-bottom-20-mobile p-1 section-margin-bottom-60" *ngIf="assignmentStatusCnts$ | async as vm;">
            <div class="row kt-margin-bottom-20-mobile" style="text-align: right; font-weight: 600; font-size: large">

                <div class="col rounded-sm p-4 m-1 d-flex align-items-center" style="color: white; background-color: #999999 !important;">
                    <div class="float-left h-100 d-flex justify-content-center align-items-center my-3">
                        <span style="vertical-align: middle; color: #E8E8E8;">
                            {{ vm.total_assignments }}
                        </span>
                    </div>
                    <div class="float-right align-content-end w-100 text-uppercase text-white">
                        <p class="m-0">
                            <span style="color: #cccccc;">ASSIGNMENTS</span>
                        </p>
                    </div>
                </div>
                <div class="col rounded-sm p-4 m-1 d-flex align-items-center" style="color: white; background-color: #f44d5e !important;">
                    <span style="vertical-align: middle; color: #E8E8E8;">
                        {{ vm.total_toes }}
                    </span>
                    <div class="float-right align-content-end w-100 text-white">
                        <p class="m-0"><span style="color: #E8E8E8;">TOEs</span></p>
                    </div>
                </div>
                <div class="col rounded-sm p-4 m-1 d-flex align-items-center" style="color: white; background-color: #fda701 !important;">
                    <span style="vertical-align: middle; color: #E8E8E8;">
                        {{ vm.total_properties }}
                    </span>
                    <div class="float-right align-content-end w-100 text-uppercase text-white">
                        <p class="m-0"><span style="color: #E8E8E8;">PROPERTIES</span></p>
                    </div>
                </div>
                <div class="col rounded-sm p-4 m-1 d-flex align-items-center" style="color: white; background-color: #16c4bb !important;">
                    <div class="float-left h-100 d-flex justify-content-center align-items-center my-3">
                        <span style="vertical-align: middle; color: #E8E8E8;">
                            {{ vm.total_valuations }}
                        </span>
                    </div>
                    <div class="float-right align-content-end w-100 text-uppercase text-white">
                        <p class="m-0">
                            <span style="color: #E8E8E8;">VALUATIONS</span> 
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <kt-filter
            [config]="{
                search: {
                    main: true,
                    location: false,
                    reset: false
                }
            }"
            (filterChange)="onFilterChange($event)">
            <kt-f-selection
                class="mr-2 mt-2"
                [key]="'pm_id'"
                [bg]="'#187016'"
                [placeholder]="'Project Manager'"
                [selections]="projectManagerSelections"></kt-f-selection>
            <kt-f-selection
                class="mr-2 mt-2"
                [key]="'agency_id'"
                [bg]="'#67a262'"
                [placeholder]="'Agency'"
                [selections]="agencySelections"></kt-f-selection>
            <kt-f-checkbox 
                [key]="'ongoing_toe'"
                [label]="'Display assignments with no ongoing ToEs'"></kt-f-checkbox>
        </kt-filter>

        <!-- MATERIAL TABLE | Binded to datasources -->
        <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->
        <div class="mat-table-wrapper">
            <mat-table class="lmat-elevation-z8 table-striped"
                       #table
                       [dataSource]="dataSource"
                       matSort
                       #sort1="matSort"
                       matSortActive="status"
                       matSortDirection="asc"
                       matSortDisableClear>
                <!-- Checkbox Column -->

                <ng-container matColumnDef="id">
                    <!-- ATTRIBUTE mat-sort-header  for sorting | https://material.angular.io/components/sort/overview -->
                    <mat-header-cell *matHeaderCellDef mat-sort-header>#</mat-header-cell>
                    <mat-cell
                            *matCellDef="let assignment">{{assignment.id}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.NAME' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">{{assignment.name}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="manager.first_name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="project-manager">
                        {{ 'ASSIGNMENT.LIST.DATATABLE.PROJECT_MANAGER' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment" class="project-manager">
                        <kt-user-tooltip [user]="convertManager(assignment)"></kt-user-tooltip>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="agency_name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.AGENCY' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">
                        {{ assignment.agency_name }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="remaining_days">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.REMAINING_DAYS' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">{{assignment.val_cnt}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="toe_cnt">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.TOE' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">{{assignment.toe_cnt}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ongoing_toe_cnt">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.TARGET_PROPERTIES' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">{{assignment.ongoing_toe_cnt}}</mat-cell>
                </ng-container>


                <ng-container matColumnDef="val_cnt">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.VALS' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">{{assignment.val_cnt}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.STATUS.COLUMN' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">
                        <b>
                             <span
                                     class="label label-inline label-rounded label-outline-{{ getItemCssClassByStatus(assignment.completion) }} label-outline-2x label-lg" style="width: 150px;">
                                {{ getItemStatusString(assignment.status, assignment.completion) }}
                            </span>
                        </b>
                        <mat-checkbox class="ml-2" *ngIf="assignment.status >= 1" [checked]="assignment.status == 2"
                            (change)="changeStatus($event, assignment)">
                        </mat-checkbox>
                        <!--<b><span-->
                        <!--class="kt-badge kt-badge&#45;&#45;inline kt-badge&#45;&#45;pill {{ assignment.status ? '' : 'kt-badge&#45;&#45;outline kt-badge&#45;&#45;outline-2x'}}  kt-badge&#45;&#45;{{ getItemCssClassByStatus(assignment.completion) }} kt-badge&#45;&#45;wide"-->
                        <!--style="width: 8rem;">{{  getItemStatusString(assignment.status, assignment.completion) }}-->
                        <!--</span></b>-->
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'ASSIGNMENT.LIST.DATATABLE.ACTIONS' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let assignment">
                        <button mat-icon-button
                                [disabled]="assignment.status === 1"
                                [matTooltip]="'ASSIGNMENT.LIST.BUTTON.DUPLICATE.TOOLTIP' | translate"
                                (click)="duplicateAssignment(assignment)"
                        >
                            <i [style.color]="assignment.status === 0 ? 'green' : 'grey'" class="flaticon2-layers"></i>
                        </button>
                        <!-- Information Tooltip -->
                        <ng-template #popContent>
                            <p [innerHTML]="'GENERAL.INFORMATION_TOOLTIP.CREATED_BY' | translate:{
                                    username: assignment.createdBy ? assignment.createdBy : 'Unknown',
                                    date: (assignment.created_at | date: 'dd MMM yyyy':currentUser.settings.time_zone_gmt)
                                }">
                            </p>
                            <p [innerHTML]="'GENERAL.INFORMATION_TOOLTIP.LAST_EDITED_BY' | translate:{
                                    username: assignment.lastUpdatedBy ? assignment.lastUpdatedBy : 'Unknown',
                                    date: (assignment.updated_at | date: 'dd MMM yyyy':currentUser.settings.time_zone_gmt)
                                }">
                            </p>
                            <div>
                                {{ 'ASSIGNMENT.LIST.POP_OVER.INFORMATION.AUDIT_TRAIL' | translate:{
                                cnt: assignment.audit_cnt
                                } }}
                            </div>
                        </ng-template>
                        <ng-template #popTitle>
                            {{ 'GENERAL.INFORMATION_TOOLTIP.TITLE' | translate }}
                        </ng-template>
                        <button mat-icon-button
                                color="primary"
                                [ngbPopover]="popContent"
                                [popoverTitle]="popTitle"
                                *ngIf="currentUser"
                        >
                            <mat-icon [matTooltip]="'GENERAL.TOOLTIP.INFORMATION' | translate">info</mat-icon>
                        </button>

                        <button mat-icon-button
                                color="primary"
                                [matTooltip]="'Edit'"
                                (click)="editAssignment(assignment)">
                            <mat-icon>create</mat-icon>
                        </button>&nbsp;

                        <span
                                [matTooltip]="assignment.relation_cnt == 0 
                                    ? ('ASSIGNMENT.LIST.BUTTON.DELETE.TOOLTIP.CAN' | translate)
                                    : ('ASSIGNMENT.LIST.BUTTON.DELETE.TOOLTIP.CANNOT' | translate) ">
                        <button mat-icon-button
                                color="warn"
                                [disabled]="assignment.relation_cnt > 0 "
                                type="button"
                                (click)="deleteAssignment(assignment)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        </span>

                        <button mat-icon-button
                                [matTooltip]="'ASSIGNMENT.LIST.BUTTON.ENTER.TOOLTIP' | translate"
                                type="button"
                                (click)="reachAssignment(assignment)">
                            <!-- <mat-icon>play_arrow</mat-icon> -->
                            <i class="flaticon2-arrow"></i>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;let index = index"
                         [ngClass]="{gray: index%2}"></mat-row>
            </mat-table>
            <!-- Message for empty data  -->
            <div class="mat-table-message" *ngIf="!dataSource.hasItems">
                {{ 'GENERAL.MESSAGE.NO_DATA' | translate }}
            </div>
            <div class="mat-table-message" *ngIf="dataSource.isPreloadTextViewed$ | async">
                {{ 'GENERAL.MESSAGE.PLEASE_WAIT' | translate }}
            </div>
        </div>

        <!-- start: BOTTOM -->
        <div class="mat-table-bottom">
            <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
            <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
            <!-- MATERIAL PAGINATOR | Binded to dasources -->
            <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
            <mat-paginator 
                [pageSize]="25" 
                [pageSizeOptions]="[25, 50, 100]" 
                [length]="dataSource.paginatorTotal$ | async"
                [pageIndex]="dataSource.pageIndex" 
                [showFirstLastButtons]="true">
            </mat-paginator>
        </div>
        <!-- end: BOTTOM -->
    </kt-portlet-body>
    <!-- end::Body -->

</kt-portlet>
